//This is the ADMIN view of all scheduled games and events

import React, { useEffect, useState } from 'react'
import './AdminScoresheet.css'
import { useParams } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
//import Modal from '../../shared/components/UIElements/Modal'
//import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminScoresheet = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [homeRoster, setHomeRoster] = useState()
	const [homeTeamName, setHomeTeamName] = useState()
	const [visitorRoster, setVisitorRoster] = useState()
	const [visitorTeamName, setVisitorTeamName] = useState()
	const [rosterPlayerGameStats, setRosterPlayerGameStats] = useState()
	const [gameStats, setGameStats] = useState([])
	const [dayOfWeek, setDayOfWeek] = useState()
	const [date, setDate] = useState()
	const [time, setTime] = useState()
	const [venue, setVenue] = useState()
	const [leagueName, setLeagueName] = useState()
	const [allPenaltiesFromThisGame, setAllPenaltiesFromThisGame] = useState()
	const gameId = useParams().gameId

	//Here, I want to go to the backend, using the gameId, and get the roster lists
	//of both the home team and the visiting team.   getGameRostersAndPointsPerPeriod in admin-controller.js
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${gameId}/rostersAndPoints`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setHomeRoster(responseData.homeRoster)
				setHomeTeamName(responseData.homeTeamName)
				setVisitorRoster(responseData.visitorRoster)
				setVisitorTeamName(responseData.visitorTeamName)
				setRosterPlayerGameStats(responseData.rosterPlayerGameStats)
				setGameStats(responseData.gameStats)
				setDayOfWeek(responseData.dayOfWeek)
				setDate(responseData.date)
				setTime(responseData.time)
				setVenue(responseData.venue)
				setLeagueName(responseData.leagueName)
				setAllPenaltiesFromThisGame(responseData.allPenaltiesFromThisGame)
				setIsLoading(false)
			} catch (err) {
				//console.log('Error: ' + err)
				setError(err)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [gameId])

	let homePoints1,
		homePoints2,
		homePoints3,
		homePoints4,
		//homePoints5,
		//homePoints6,
		homePointsTotal
	let visitorPoints1,
		visitorPoints2,
		visitorPoints3,
		visitorPoints4,
		//visitorPoints5,
		//visitorPoints6,
		visitorPointsTotal
	//status,
	//summary
	if (gameStats) {
		if (gameStats.length > 0) {
			//console.log('WE HAVE GAME STATS')
			//console.log('gameStats: ' + JSON.stringify(gameStats))
			homePoints1 = gameStats[0].homeGoalsPeriod1
			homePoints2 = gameStats[0].homeGoalsPeriod2
			homePoints3 = gameStats[0].homeGoalsPeriod3
			homePoints4 = gameStats[0].homeGoalsPeriod4
			//homePoints5 = gameStats[0].homeGoalsPeriod5
			//homePoints6 = gameStats[0].homeGoalsPeriod6
			homePointsTotal = gameStats[0].homeGoalsTotal
			visitorPoints1 = gameStats[0].visitorGoalsPeriod1
			visitorPoints2 = gameStats[0].visitorGoalsPeriod2
			visitorPoints3 = gameStats[0].visitorGoalsPeriod3
			visitorPoints4 = gameStats[0].visitorGoalsPeriod4
			//visitorPoints5 = gameStats[0].visitorGoalsPeriod5
			//visitorPoints6 = gameStats[0].visitorGoalsPeriod6
			visitorPointsTotal = gameStats[0].visitorGoalsTotal
			//status = gameStats[0].status
			//summary = gameStats[0].summary
			//console.log('summary here: ' + summary)
			//console.log('homeGoalsTotal here: ' + homePointsTotal)
		}
	} else {
		console.log('NO GAME STATS YET!!!')
	}
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//console.log('home roster: ' + JSON.stringify(homeRoster))
	//console.log('visitor roster: ' + JSON.stringify(visitorRoster))

	let bothRosterDropdown
	bothRosterDropdown = []
	if (homeRoster && visitorRoster) {
		homeRoster.forEach((homePlayer) => {
			bothRosterDropdown.push(
				homePlayer.teamName +
					' - ' +
					homePlayer.number +
					' - ' +
					homePlayer.firstName +
					' ' +
					homePlayer.lastName
			)
		})
		visitorRoster.forEach((visitorPlayer) => {
			bothRosterDropdown.push(
				visitorPlayer.teamName +
					' - ' +
					visitorPlayer.number +
					' - ' +
					visitorPlayer.firstName +
					' ' +
					visitorPlayer.lastName
			)
		})
	}

	//console.log('bothRosterDropdown: ' + bothRosterDropdown)
	//
	//
	//
	const returnGoals = (playerId) => {
		let gameGoals
		rosterPlayerGameStats.forEach((rosterPlayer) => {
			if (rosterPlayer.rosterPlayerId === playerId) {
				gameGoals = rosterPlayer.goals
			}
		})
		return gameGoals
	}
	//
	//
	//
	const returnAssists = (playerId) => {
		let gameAssists
		rosterPlayerGameStats.forEach((rosterPlayer) => {
			if (rosterPlayer.rosterPlayerId === playerId) {
				gameAssists = rosterPlayer.assists
			}
		})
		return gameAssists
	}
	//
	//
	//let navigate = useNavigate()
	//
	//
	//
	//
	//Here, let's see if there were any penalties in this game, and we'll
	//populate the penalties if so
	let previousPenaltyPlayer1,
		previousPenaltyOffense1,
		previousPenaltyPd1,
		previousPenaltyTiming1,
		previousPim1,
		previousPenaltyPlayer2,
		previousPenaltyOffense2,
		previousPenaltyPd2,
		previousPenaltyTiming2,
		previousPim2,
		previousPenaltyPlayer3,
		previousPenaltyOffense3,
		previousPenaltyPd3,
		previousPenaltyTiming3,
		previousPim3,
		previousPenaltyPlayer4,
		previousPenaltyOffense4,
		previousPenaltyPd4,
		previousPenaltyTiming4,
		previousPim4,
		previousPenaltyPlayer5,
		previousPenaltyOffense5,
		previousPenaltyPd5,
		previousPenaltyTiming5,
		previousPim5,
		previousPenaltyPlayer6,
		previousPenaltyOffense6,
		previousPenaltyPd6,
		previousPenaltyTiming6,
		previousPim6,
		previousPenaltyPlayer7,
		previousPenaltyOffense7,
		previousPenaltyPd7,
		previousPenaltyTiming7,
		previousPim7,
		previousPenaltyPlayer8,
		previousPenaltyOffense8,
		previousPenaltyPd8,
		previousPenaltyTiming8,
		previousPim8,
		previousPenaltyPlayer9,
		previousPenaltyOffense9,
		previousPenaltyPd9,
		previousPenaltyTiming9,
		previousPim9,
		previousPenaltyPlayer10,
		previousPenaltyOffense10,
		previousPenaltyPd10,
		previousPenaltyTiming10,
		previousPim10

	/* allPenaltiesFromThisGame &&
		console.log(
			'allPenaltiesFromThisGame: ' + JSON.stringify(allPenaltiesFromThisGame)
		) */
	if (allPenaltiesFromThisGame) {
		if (allPenaltiesFromThisGame[0]) {
			previousPenaltyPlayer1 =
				allPenaltiesFromThisGame[0].teamName +
				' - ' +
				allPenaltiesFromThisGame[0].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[0].firstName +
				' ' +
				allPenaltiesFromThisGame[0].lastName
			previousPenaltyOffense1 = allPenaltiesFromThisGame[0].penaltyType
			previousPenaltyPd1 = allPenaltiesFromThisGame[0].period
			previousPenaltyTiming1 = allPenaltiesFromThisGame[0].time
			previousPim1 = allPenaltiesFromThisGame[0].minutes
		}
		//
		if (allPenaltiesFromThisGame[1]) {
			previousPenaltyPlayer2 =
				allPenaltiesFromThisGame[1].teamName +
				' - ' +
				allPenaltiesFromThisGame[1].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[1].firstName +
				' ' +
				allPenaltiesFromThisGame[1].lastName
			previousPenaltyOffense2 = allPenaltiesFromThisGame[1].penaltyType
			previousPenaltyPd2 = allPenaltiesFromThisGame[1].period
			previousPenaltyTiming2 = allPenaltiesFromThisGame[1].time
			previousPim2 = allPenaltiesFromThisGame[1].minutes
		}
		//
		if (allPenaltiesFromThisGame[2]) {
			previousPenaltyPlayer3 =
				allPenaltiesFromThisGame[2].teamName +
				' - ' +
				allPenaltiesFromThisGame[2].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[2].firstName +
				' ' +
				allPenaltiesFromThisGame[2].lastName
			previousPenaltyOffense3 = allPenaltiesFromThisGame[2].penaltyType
			previousPenaltyPd3 = allPenaltiesFromThisGame[2].period
			previousPenaltyTiming3 = allPenaltiesFromThisGame[2].time
			previousPim3 = allPenaltiesFromThisGame[2].minutes
		}
		//
		if (allPenaltiesFromThisGame[3]) {
			previousPenaltyPlayer4 =
				allPenaltiesFromThisGame[3].teamName +
				' - ' +
				allPenaltiesFromThisGame[3].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[3].firstName +
				' ' +
				allPenaltiesFromThisGame[3].lastName
			previousPenaltyOffense4 = allPenaltiesFromThisGame[3].penaltyType
			previousPenaltyPd4 = allPenaltiesFromThisGame[3].period
			previousPenaltyTiming4 = allPenaltiesFromThisGame[3].time
			previousPim4 = allPenaltiesFromThisGame[3].minutes
		}
		//
		if (allPenaltiesFromThisGame[4]) {
			previousPenaltyPlayer5 =
				allPenaltiesFromThisGame[4].teamName +
				' - ' +
				allPenaltiesFromThisGame[4].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[4].firstName +
				' ' +
				allPenaltiesFromThisGame[4].lastName
			previousPenaltyOffense5 = allPenaltiesFromThisGame[4].penaltyType
			previousPenaltyPd5 = allPenaltiesFromThisGame[4].period
			previousPenaltyTiming5 = allPenaltiesFromThisGame[4].time
			previousPim5 = allPenaltiesFromThisGame[4].minutes
		}
		//
		if (allPenaltiesFromThisGame[5]) {
			previousPenaltyPlayer6 =
				allPenaltiesFromThisGame[5].teamName +
				' - ' +
				allPenaltiesFromThisGame[5].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[5].firstName +
				' ' +
				allPenaltiesFromThisGame[5].lastName
			previousPenaltyOffense6 = allPenaltiesFromThisGame[5].penaltyType
			previousPenaltyPd6 = allPenaltiesFromThisGame[5].period
			previousPenaltyTiming6 = allPenaltiesFromThisGame[5].time
			previousPim6 = allPenaltiesFromThisGame[5].minutes
		}
		//
		if (allPenaltiesFromThisGame[6]) {
			previousPenaltyPlayer7 =
				allPenaltiesFromThisGame[6].teamName +
				' - ' +
				allPenaltiesFromThisGame[6].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[6].firstName +
				' ' +
				allPenaltiesFromThisGame[6].lastName
			previousPenaltyOffense7 = allPenaltiesFromThisGame[6].penaltyType
			previousPenaltyPd7 = allPenaltiesFromThisGame[6].period
			previousPenaltyTiming7 = allPenaltiesFromThisGame[6].time
			previousPim7 = allPenaltiesFromThisGame[6].minutes
		}
		//
		if (allPenaltiesFromThisGame[7]) {
			previousPenaltyPlayer8 =
				allPenaltiesFromThisGame[7].teamName +
				' - ' +
				allPenaltiesFromThisGame[7].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[7].firstName +
				' ' +
				allPenaltiesFromThisGame[7].lastName
			previousPenaltyOffense8 = allPenaltiesFromThisGame[7].penaltyType
			previousPenaltyPd8 = allPenaltiesFromThisGame[7].period
			previousPenaltyTiming8 = allPenaltiesFromThisGame[7].time
			previousPim8 = allPenaltiesFromThisGame[7].minutes
		}
		//
		if (allPenaltiesFromThisGame[8]) {
			previousPenaltyPlayer9 =
				allPenaltiesFromThisGame[8].teamName +
				' - ' +
				allPenaltiesFromThisGame[8].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[8].firstName +
				' ' +
				allPenaltiesFromThisGame[8].lastName
			previousPenaltyOffense9 = allPenaltiesFromThisGame[8].penaltyType
			previousPenaltyPd9 = allPenaltiesFromThisGame[8].period
			previousPenaltyTiming9 = allPenaltiesFromThisGame[8].time
			previousPim9 = allPenaltiesFromThisGame[8].minutes
		}
		//
		if (allPenaltiesFromThisGame[9]) {
			previousPenaltyPlayer10 =
				allPenaltiesFromThisGame[9].teamName +
				' - ' +
				allPenaltiesFromThisGame[9].jerseyNumber +
				' - ' +
				allPenaltiesFromThisGame[9].firstName +
				' ' +
				allPenaltiesFromThisGame[9].lastName
			previousPenaltyOffense10 = allPenaltiesFromThisGame[9].penaltyType
			previousPenaltyPd10 = allPenaltiesFromThisGame[9].period
			previousPenaltyTiming10 = allPenaltiesFromThisGame[9].time
			previousPim10 = allPenaltiesFromThisGame[9].minutes
		}
	}
	//
	//
	//
	//
	return (
		<React.Fragment>
			<div style={{ backgroundColor: 'white' }}>
				{/* {(document.body.style.backgroundColor = 'white')} */}
				{/* <AdminNavigation /> */}
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				<span>
					<h5 style={{ paddingTop: '1rem' }}>
						{leagueName && leagueName}: {homeTeamName} vs. {visitorTeamName}
					</h5>
					<p style={{ textAlign: 'center' }}>
						{dayOfWeek},{' '}
						{date && date.substr(0, 2) === '01' && 'Jan. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '02' && 'Feb. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '03' && 'Mar. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '04' && 'Apr. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '05' && 'May ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '06' && 'June ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '07' && 'July ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '08' && 'Aug. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '09' && 'Sept. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '10' && 'Oct. ' + date.substr(3, 2)}
						{date && date.substr(0, 2) === '11' && 'Nov. ' + date.substr(3, 2)}
						{date &&
							date.substr(0, 2) === '12' &&
							'Dec. ' + date.substr(3, 2)},{' '}
						{time &&
							time.substr(0, 2) === '01' &&
							'1:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '02' &&
							'2:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '03' &&
							'3:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '04' &&
							'4:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '05' &&
							'5:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '06' &&
							'6:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '07' &&
							'7:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '08' &&
							'8:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '09' &&
							'9:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '10' &&
							'10:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '11' &&
							'11:' + time.substr(3, 2) + ' am'}
						{time &&
							time.substr(0, 2) === '12' &&
							'12:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '13' &&
							'1:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '14' &&
							'2:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '15' &&
							'3:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '16' &&
							'4:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '17' &&
							'5:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '18' &&
							'6:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '19' &&
							'7:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '20' &&
							'8:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '21' &&
							'9:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '22' &&
							'10:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '23' &&
							'11:' + time.substr(3, 2) + ' pm'}
						{time &&
							time.substr(0, 2) === '24' &&
							'12:' + time.substr(3, 2) + ' am'}
						, {venue}
					</p>
					<p style={{ textAlign: 'center' }}>
						Referees: ___________________________________________
					</p>
				</span>

				<table
					className='Scoresheet'
					id='scoresheet'
					style={{ width: '40%', marginBottom: '0rem' }}
				>
					<thead>
						<tr>
							<th>Team</th>
							<th>Pd. 1</th>
							<th>Pd. 2</th>
							<th>Pd. 3</th>
							<th>OT</th>
							{/* <th>5</th>
						<th>6</th> */}
							<th>Final</th>
						</tr>
					</thead>
					<tbody>
						<tr style={{ height: '5px' }}>
							<td>HOME: {homeTeamName}</td>
							<td>{homePoints1}</td>
							<td>{homePoints2}</td>
							<td>{homePoints3}</td>
							<td>{homePoints4}</td>
							<td>{homePointsTotal}</td>
						</tr>
						<tr>
							<td>AWAY: {visitorTeamName}</td>
							<td>{visitorPoints1}</td>
							<td>{visitorPoints2}</td>
							<td>{visitorPoints3}</td>
							<td>{visitorPoints4}</td>
							<td>{visitorPointsTotal}</td>
						</tr>
					</tbody>
				</table>
				<div className='row'>
					<div className='col' style={{ marginLeft: '5%' }}>
						{!isLoading && homeRoster && visitorRoster && (
							<div className='Scoresheet2'>
								{/* <AdminNavigation /> */}
								<div>
									<h5 className='h5Left'>Home: {homeTeamName}</h5>
									{/* <h3 className='h3Left'>Player Stats</h3>
								<h5 className='h5Left'>
									(Players listed in alphabetical order by last name.)
								</h5> */}
								</div>
								<table id='scoresheet' style={{ marginLeft: '0%' }}>
									<thead>
										<tr>
											<th>#</th>
											<th>Player</th>
											<th>Goals</th>
											<th>Assists</th>
											{/* <th>PIM</th> */}
										</tr>
									</thead>
									<tbody>
										{homeRoster.map((player, key) => {
											return (
												<tr key={key}>
													{/* <td>{player.number}</td> */}
													<td>{player.number}</td>
													<td>
														{player.firstName}{' '}
														{player.middleInitial && player.middleInitial}{' '}
														{player.lastName}
													</td>
													<td>{returnGoals(player._id)}</td>
													<td>{returnAssists(player._id)}</td>
													{/* <td></td> */}
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						)}
					</div>
					<div className='col' style={{ marginLeft: '5%' }}>
						{!isLoading && homeRoster && visitorRoster && (
							<div className='Scoresheet2'>
								<div>
									<h5 className='h5Left'>Visitor: {visitorTeamName}</h5>
									{/* <h3 className='h3Left'>Player Stats</h3>
								<h5 className='h5Left'>
									(Players listed in alphabetical order by last name.)
								</h5> */}
								</div>
								<table id='scoresheet' style={{ marginLeft: '0%' }}>
									<thead>
										<tr>
											<th>#</th>
											<th>Player</th>
											<th>Goals</th>
											<th>Assists</th>
											{/* <th>PIM</th> */}
										</tr>
									</thead>
									<tbody>
										{visitorRoster.map((player, key) => {
											return (
												<tr key={key}>
													<td>{player.number}</td>
													<td>
														{player.firstName}{' '}
														{player.middleInitial && player.middleInitial}{' '}
														{player.lastName}
													</td>
													<td>{returnGoals(player._id)}</td>
													<td>{returnAssists(player._id)}</td>
													{/* <td></td> */}
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						)}
					</div>
				</div>
				<div>
					<h5 style={{ marginTop: '2rem' }}>Penalties</h5>
					<table
						className='Scoresheet'
						id='scoresheet'
						style={{ width: '40%', marginBottom: '0rem', marginTop: '0.5rem' }}
					>
						<thead>
							<tr>
								<th>Player</th>
								<th>Penalty</th>
								<th>Period</th>
								<th>Time</th>
								<th>Minutes</th>
							</tr>
						</thead>
						<tbody>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer1}</td>
								<td>{previousPenaltyOffense1}</td>
								<td>{previousPenaltyPd1}</td>
								<td>{previousPenaltyTiming1}</td>
								<td>{previousPim1}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer2}</td>
								<td>{previousPenaltyOffense2}</td>
								<td>{previousPenaltyPd2}</td>
								<td>{previousPenaltyTiming2}</td>
								<td>{previousPim2}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer3}</td>
								<td>{previousPenaltyOffense3}</td>
								<td>{previousPenaltyPd3}</td>
								<td>{previousPenaltyTiming3}</td>
								<td>{previousPim3}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer4}</td>
								<td>{previousPenaltyOffense4}</td>
								<td>{previousPenaltyPd4}</td>
								<td>{previousPenaltyTiming4}</td>
								<td>{previousPim4}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer5}</td>
								<td>{previousPenaltyOffense5}</td>
								<td>{previousPenaltyPd5}</td>
								<td>{previousPenaltyTiming5}</td>
								<td>{previousPim5}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer6}</td>
								<td>{previousPenaltyOffense6}</td>
								<td>{previousPenaltyPd6}</td>
								<td>{previousPenaltyTiming6}</td>
								<td>{previousPim6}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer7}</td>
								<td>{previousPenaltyOffense7}</td>
								<td>{previousPenaltyPd7}</td>
								<td>{previousPenaltyTiming7}</td>
								<td>{previousPim7}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer8}</td>
								<td>{previousPenaltyOffense8}</td>
								<td>{previousPenaltyPd8}</td>
								<td>{previousPenaltyTiming8}</td>
								<td>{previousPim8}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer9}</td>
								<td>{previousPenaltyOffense9}</td>
								<td>{previousPenaltyPd9}</td>
								<td>{previousPenaltyTiming9}</td>
								<td>{previousPim9}</td>
							</tr>
							<tr style={{ height: '5px' }}>
								<td>{previousPenaltyPlayer10}</td>
								<td>{previousPenaltyOffense10}</td>
								<td>{previousPenaltyPd10}</td>
								<td>{previousPenaltyTiming10}</td>
								<td>{previousPim10}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div
					style={{
						marginTop: '1rem',
						marginLeft: '5rem',
						paddingBottom: '3rem',
					}}
				>
					<button
						className='okButton buttonButton'
						inverse
						// onClick={printDiv('regPlayers')}
						onClick={() => window.print()}
					>
						PRINT THIS LIST
					</button>
				</div>
			</div>
		</React.Fragment>
	)
}

export default AdminScoresheet
